export const colors = {
  black: '#000000',
  white: '#ffffff',
  primary: '#f3f7fd',
  secondary: '#234cad',
  tertiary: '#f2f6ff',
  lightGreen: '#e7f4ec',
  green: '#6abd90',
  grey: '#ccc',
};

export const shadows = {
  primary: '0px 0px 10px #00486C33',
};

export const layout = {
  marginWithFooter: '100px',
  footerHeight: '100px',
  headerHeight: '65px',
  contentAvailable: 'calc(100vh - 265px)',
};
